import React from 'react'
import { Trans } from 'react-i18next'
import BaseGrinNotification from './BaseGrinNotification/BaseGrinNotification'
import useSelectPatient from 'hooks/useSelectPatient'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import { usePatientFromNotification } from './hooks/usePatientFromNotification'

/**
 * @param {NotificationComponentProps} props
 */
const PatientAssignedNotification = ({ grinNotification, options }) => {
  const selectPatient = useSelectPatient({
    patientId: grinNotification?.relatedPatientId
  })

  const patient = usePatientFromNotification(grinNotification)

  return (
    <BaseGrinNotification
      grinNotification={grinNotification}
      isLastItem={options.isLastItem}
      showPracticeName={options.showPracticeName}
      profilePicture={patient?.profilePicture}
      profilePictureUserName={patient?.name}
      onClick={selectPatient}
    >
      <DazzedParagraph14 strong>
        <Trans
          i18nKey={`dialogs.notificationCenterDialog.feed.notifications.patientAssigned.body`}
          values={{
            patientName: patient?.name,
            assignerName: grinNotification.payload.assignerName
          }}
        />
      </DazzedParagraph14>
    </BaseGrinNotification>
  )
}

export default PatientAssignedNotification
